import React, { useState, useEffect } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Button from './../button/Button';
import MediaLoad from '../media-load/MediaLoad';
import axios from 'axios';
import ApiUrl from './../../services/ApiUrl';
import Textarea from './../input/Textarea';
import { useSelector } from 'react-redux';

const IconDesc = ( props ) => {
    let [ error, setErrors ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);

    useEffect(() => {
        if(props.validate) {
            validate();
        }
    }, [props.validate])

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(errors) {
            setErrors(true);
        }else{
            setErrors(false);
        }
    }

    const updateFields = (val, index, label) => {
        let newData = props.data;
        newData.map((item, i) => i == index ? item[label] = val : item);
        props.setFunction(newData);
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.icon-desc.error`);
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    const handleKeyDown = (e, functionName, functionValue = false) => {
        if (e.key === 'Enter') {
            functionName(functionValue)
        }
    }

    const rolledSection = (index) => {
        if(typeof window !== "undefined") {
            let sections = document.querySelectorAll(`.icon-desc .icon-desc-content`);
            sections[index].children[1].classList.toggle('active');
        }
    }

    const addItem = () => {
        let newData = [...props.data, {
            image: '',
            desc: '',
        }]
        props.setFunction(newData);
    }

    const removeItem = (index) => {
        let newData = props.data.filter((item, i) => i == index ? false : item);
        props.setFunction(newData);
    }

    const handleRLDDChange = (result) => {
        if (!result.destination) return;
        const items = Array.from(props.data);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        props.setFunction(items);
    }
    
    return (
        <div className={error ? `section-wrapper icon-desc error-section` : `section-wrapper icon-desc`}>
                <DragDropContext onDragEnd={handleRLDDChange}>
                <Droppable droppableId="section-items">
                    {(provided) => (
                        <div className="section-items" {...provided.droppableProps} ref={provided.innerRef}>
                        {props.data && props.data.map((item, index) => (
                            <Draggable key={String(index)} draggableId={String(index)} index={index}>
                                {(provided) => provided && (
                                    <div className="icon-desc-content" {...provided.draggableProps} ref={provided.innerRef}>
                                        <div className="section-index">
                                            <span onClick={() => rolledSection(index)}
                                                aria-label="Zwiń lub rozwiń sekcje"
                                                tabIndex="0"
                                                role="button"
                                                onKeyDown={(e) => handleKeyDown(e, rolledSection, index)}>Ikona {index + 1}</span>
                                            {!error &&
                                            <i {...provided.dragHandleProps} 
                                                className="material-icons"
                                                aria-label="Przeciągnij sekcje"
                                                tabIndex="0"
                                                role="button">open_with</i>
                                            }
                                            <i onClick={() => removeItem(index)} 
                                                aria-label="Usuń sekcje"
                                                tabIndex="0"
                                                role="button"
                                                onKeyDown={(e) => handleKeyDown(e, removeItem, index)}
                                                className="material-icons remove-item-icon">delete</i>
                                        </div>
                                        <div className="content">
                                            <div className="row-section">
                                                <div className="row-section">
                                                    <MediaLoad setFunction={ val => updateFields(val, index, 'image') } value={item.image} label="Ikona" />
                                                </div>
                                                <div className="row-section">
                                                    <Textarea  required={ true }
                                                        setFunction={ val => updateFields(val, index, "desc") }
                                                        value={item.desc}
                                                        label={ 'Opis' }
                                                        regExp={ /.*/ }
                                                        minChar={ 3 } 
                                                        forceValidate={ forceValidate } 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <div className="add-item-in-section">
                <Button title="Dodaj Kolejną ikone" setFunction={() => addItem()} />   
            </div>
        </div>
    );
}

export default IconDesc;